<template>
<div class="home-container">
  <!-- 权限验证失败提示 -->
  <div v-if="!isAuthenticated && !loading" class="auth-error">
    <div class="error-content">
      <h2>Token验证失败</h2>
      <p>无法验证您的身份，请检查URL参数是否正确</p>
      <p>需要参数：username, timestamp, token</p>
    </div>
  </div>

  <!-- 加载中提示 -->
  <div v-if="loading" class="loading-container">
    <div class="loading-content">
      <h2>正在验证权限...</h2>
      <p>请稍候</p>
    </div>
  </div>

  <!-- 主要内容区域 - 只有通过权限验证才显示 -->
  <div v-if="isAuthenticated && !loading">
    <!-- 顶部导航栏 -->
    <div class="topbar">
      <div class="topbar-left">
        <img class="topbar-logo" src="images/alram/4ddfcd7347a535f4cf1986b1725e7ffb.png" />
        <span class="topbar-title">光电园区智慧云控平台</span>
      </div>
      <div class="topbar-right">
        <span class="topbar-company">天津光电集团</span>
      </div>
    </div>

    <div class="main-layout">
      <!-- 左侧导航菜单 -->
      <nav class="sidebar">
        <!-- 环境监测 -->
        <div v-if="hasPermission('environmental')" class="nav-item" :class="{ active: activeMainNav === 1 }" @click="switchMainNav(1)">
          <img class="nav-icon" src="images/alram/128a02d200f7fd70fd56573b5229b078.png" />
          <span class="nav-text">环境监测</span>
        </div>
        
        <!-- AI全域智控 -->
        <div v-if="hasPermission('aicontrol')" class="nav-item" :class="{ active: activeMainNav === 2 }" @click="switchMainNav(2)">
          <img class="nav-icon" src="images/alram/c862476ba55ead5210fb0fadd1a768b9.png" />
          <span class="nav-text">全域智控</span>
        </div>
        
        <!-- 智慧宿舍 -->
        <div v-if="hasPermission('hostel')" class="nav-item" :class="{ active: activeMainNav === 3 }" @click="switchMainNav(3)">
          <img class="nav-icon" src="images/alram/b086989d13f84a679f3d8ea52c7bdea0.png" />
          <span class="nav-text">智慧宿舍</span>
        </div>
        
        <!-- 智能巡更 -->
        <div v-if="hasPermission('patrol')" class="nav-item" @click="goToPatrol">
          <img class="nav-icon" src="images/alram/19eaeb77041531fa92c98d71d0a7feea.png" />
          <span class="nav-text">智能巡更</span>
        </div>
        
        <!-- 权限管理 -->
        <div v-if="hasPermission('user')" class="nav-item" :class="{ active: activeMainNav === 4 }" @click="switchMainNav(4)">
          <img class="nav-icon" src="images/alram/u327.png" />
          <span class="nav-text">权限管理</span>
        </div>

        <!-- 智慧洗衣 -->
        <div v-if="hasPermission('laundry')" class="nav-item" :class="{ active: activeMainNav === 5 }" @click="switchMainNav(5)">
          <img class="nav-icon" src="images/alram/洗衣机.svg" />
          <span class="nav-text">智慧洗衣</span>
        </div>

        <!-- 水电表 -->
        <div class="nav-item" :class="{ active: activeMainNav === 6 }" @click="switchMainNav(6)">
          <img class="nav-icon" src="images/alram/meter.svg" />
          <span class="nav-text">能源监测</span>
        </div>
      </nav>
      <!-- 主要内容区域 -->
      <main class="main-content">
        <!-- 二级导航栏 - 环境监测 -->
        <div v-if="activeMainNav === 1 && hasPermission('environmental')" class="subnav-bar">
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/monitor') }"
            to="/home/monitor"
          >实时监测</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/meter') }"
            to="/home/meter"
          >表具管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/history') }"
            to="/home/history"
          >历史查询</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/device') }"
            to="/home/device"
          >设备维修</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/analysis') }"
            to="/home/analysis"
          >统计分析</router-link>
        </div>

        <!-- 二级导航栏 - AI全域智控 -->
        <div v-if="activeMainNav === 2 && hasPermission('aicontrol')" class="subnav-bar">
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/traffic') }"
            to="/home/traffic"
          >智控交通</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/substation') }"
            to="/home/substation"
          >变电站</router-link>
        </div>

        <!-- 二级导航栏 - 智慧宿舍 -->
        <div v-if="activeMainNav === 3 && hasPermission('hostel')" class="subnav-bar">
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/VisualDormitory') }"
            to="/home/VisualDormitory"
          >可视化平台</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/dormitory') }"
            to="/home/dormitory"
          >宿舍管理</router-link>
        </div>

        <!-- 二级导航栏 - 权限管理 -->
        <div v-if="activeMainNav === 4 && hasPermission('user')" class="subnav-bar">
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/permission') }"
            to="/home/permission"
          >权限管理</router-link>
        </div>

        <!-- 二级导航栏 - 智慧洗衣 -->
        <div v-if="activeMainNav === 5 && hasPermission('laundry')" class="subnav-bar">
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-stats') }"
            to="/home/laundry-stats"
          >统计分析</router-link>
          <router-link  
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-order') }"
            to="/home/laundry-order"
          >订单管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-device') }"
            to="/home/laundry-device"
          >设备管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-notification') }"
            to="/home/laundry-notification"
          >消息推送</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-complaint') }"
            to="/home/laundry-complaint"
          >投诉处理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-user') }"
            to="/home/laundry-user"
          >用户管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-permission') }"
            to="/home/laundry-permission"
          >权限管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/laundry-report') }"
            to="/home/laundry-report"
          >报表管理</router-link>
        </div>
        <div v-if="activeMainNav === 6 && hasPermission('engery')" class="subnav-bar">
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery') }"
            to="/home/engery"
          >能效分析</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery-monitor') }"
            to="/home/engery-monitor"
          >实时监控</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery-sample') }"
            to="/home/engery-sample"
          >抄表管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery-manage') }"
            to="/home/engery-manage"
          >表具管理</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery-history') }"
            to="/home/engery-history"
          >历史查询</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery-repair') }"
            to="/home/engery-repair"
          >设备维修</router-link>
          <router-link
            class="subnav-tab"
            :class="{ active: $route.path.endsWith('/engery-statistics') }"
            to="/home/engery-statistics"
          >统计分析</router-link>
        </div>
        <router-view />
      </main>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HomePage',
  data() {
    return {
      activeMainNav: 2 // 默认激活AI全域智控
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'hasPermission',
      'getUserInfo'
    ]),
    loading() {
      return this.$store.state.loading
    }
  },
  async mounted() {
    // 页面加载时进行权限验证
    await this.initAuth()
    
    // 如果验证成功，设置导航状态
    if (this.isAuthenticated) {
      this.setActiveNavFromRoute()
    }
  },
  watch: {
    // 监听路由变化，自动更新导航状态
    '$route'() {
      if (this.isAuthenticated) {
        this.setActiveNavFromRoute()
      }
    }
  },
  methods: {
    ...mapActions(['initAuth']),
    
    // 根据当前路由设置激活的导航项
    setActiveNavFromRoute() {
      const currentPath = this.$route.path;
      
      // 根据路由路径判断应该激活哪个主导航
      if (currentPath.includes('/monitor') || currentPath.includes('/meter') || 
          currentPath.includes('/history') || currentPath.includes('/device') || 
          currentPath.includes('/analysis')) {
        this.activeMainNav = 1; // 环境监测
      } else if (currentPath.includes('/traffic') || currentPath.includes('/substation')) {
        this.activeMainNav = 2; // AI全域智控
      } else if (currentPath.includes('/VisualDormitory') || currentPath.includes('/dormitory')) {
        this.activeMainNav = 3; // 智慧宿舍
      } else if (currentPath.includes('/permission')) {
        this.activeMainNav = 4; // 权限管理
      } else if (currentPath.includes('/laundry')) {
        this.activeMainNav = 5; // 智慧洗衣
      } else if (currentPath.includes('/engery')) {
        this.activeMainNav = 6; // 智慧洗衣
      } else {
        // 默认情况，根据权限选择第一个可用的模块
        if (this.hasPermission('aicontrol')) {
          this.activeMainNav = 2
        } else if (this.hasPermission('environmental')) {
          this.activeMainNav = 1
        } else if (this.hasPermission('hostel')) {
          this.activeMainNav = 3
        } else if (this.hasPermission('user')) {
          this.activeMainNav = 4
        } else if (this.hasPermission('laundry')) {
          this.activeMainNav = 5
        } else if (this.hasPermission('engery')) {
          this.activeMainNav = 6
        }
      }
    },
    
    // 切换主导航
    switchMainNav(index) {
      this.activeMainNav = index;
      
      // 切换一级菜单时自动跳转到对应的二级菜单默认页面
      const routeMap = {
        1: '/home/monitor',
        2: '/home/traffic',
        3: '/home/VisualDormitory',
        4: '/home/permission',
        5: '/home/laundry-stats',
        6: '/home/engery'
      };
      
      const targetRoute = routeMap[index];
      if (targetRoute) {
        this.$router.push(targetRoute);
      }
    },
    
    // 获取导航对应的权限key
    getPermissionKey(index) {
      const permissionMap = {
        1: 'environmental',
        2: 'aicontrol',
        3: 'hostel',
        4: 'user',
        5: 'laundry',
        6: 'engery'
      };
      return permissionMap[index];
    },
    
    // 跳转到智能巡更（外部链接）
    goToPatrol() {
      if (this.hasPermission('patrol')) {
        window.location.href = 'http://47.93.132.27:5050/';
      }
    }
  }
}
</script>

<style scoped>
/* 权限验证失败样式 */
.auth-error {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.error-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-width: 500px;
}

.error-content h2 {
  color: #e74c3c;
  margin-bottom: 16px;
  font-size: 24px;
}

.error-content p {
  color: #666;
  margin-bottom: 8px;
  font-size: 16px;
}

/* 加载中样式 */
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-width: 300px;
}

.loading-content h2 {
  color: #1976d2;
  margin-bottom: 16px;
  font-size: 20px;
}

.loading-content p {
  color: #666;
  font-size: 14px;
}

/* 其他样式待补充 */
</style>